import { popupConstants } from '../constants';

const initialState = {
    loading: false,
    popups: [],
    error: null,
    creatingPopup: false,
    createError: null,
    updatingPopup: false,
    updateError: null,
};

const popupReducer = (state = initialState, action) => {
    switch (action.type) {
        case popupConstants.FETCH_POPUPS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case popupConstants.FETCH_POPUPS_SUCCESS:
            return {
                ...state,
                loading: false,
                popups: action.popups,
                error: null
            };
        case popupConstants.FETCH_POPUPS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case popupConstants.CREATE_POPUP_REQUEST:
            return {
                ...state,
                creatingPopup: true,
                createError: null,
            };
        case popupConstants.CREATE_POPUP_SUCCESS:
            return {
                ...state,
                creatingPopup: false,
                popups: action.popups,
            };
        case popupConstants.CREATE_POPUP_FAILURE:
            return {
                ...state,
                creatingPopup: false,
                createError: action.payload,
            };

        case popupConstants.UPDATE_POPUP_REQUEST:
            return {
                ...state,
                updatingPopup: true,
                updateError: null,
            };
        case popupConstants.UPDATE_POPUP_SUCCESS:
            return {
                ...state,
                popups: action.popups,
                updatingPopup: false,
                updateError: null,
            };
        case popupConstants.UPDATE_POPUP_FAILURE:
            return {
                ...state,
                updatingPopup: false,
                updateError: action.payload,
            };
        case popupConstants.DELETE_POPUP_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case popupConstants.DELETE_POPUP_SUCCESS:
            return {
                ...state,
                loading: false,
                popups: state.popups.filter(p => p.PopupId !== action.payload),
            };
        case popupConstants.DELETE_POPUP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default popupReducer;
